module.exports = __webpack_public_path__ + "img/standard.38c082c1.png";